<div class="section-dialog-information-app">
    <div class="content-dialog" >
        <h2 mat-dialog-title>{{ "InformationModalTitle" | translate }}</h2>
        
        <mat-dialog-content class="mat-typography">
          <p>{{ "InformationModalMessage" | translate }}</p>
        </mat-dialog-content>
    
      </div>
</div>

<mat-dialog-actions align="center">
    <div class="container-btn-reservation">
      <button
        mat-raised-button
        class="btn-reservation btn-accept"
        (click)="cancel()"
      >
        {{ "Back" | translate | uppercase}}
      </button>
    </div>
</mat-dialog-actions>